<script setup lang="ts">
import type { PeekPriceModalItineraryData } from '../../models';
import {
  isPeekPriceModalHotelOnlyItinerary,
  isPeekPriceModalFlightPlusHotelItinerary,
  isPeekPriceModalFerryPlusHotelItinerary,
  isPeekPriceModalMultiIngredientItinerary,
} from '../../models';

import PeekPriceBookableTransportPlusHotel from './PeekPriceBookableTransportPlusHotel.vue';
import PeekPriceLargeHotelCard from './PeekPriceLargeHotelCard.vue';
import PeekPriceMultiIngredient from './PeekPriceMultiIngredient.vue';

interface PeekPriceModalItineraryProps {
  itinerary: PeekPriceModalItineraryData;
}

const props = defineProps<PeekPriceModalItineraryProps>();
</script>

<template>
  <div class="peek-price-modal-itinerary">
    <PeekPriceLargeHotelCard
      v-if="isPeekPriceModalHotelOnlyItinerary(props.itinerary)"
      :itinerary="props.itinerary"
    />

    <PeekPriceBookableTransportPlusHotel
      v-if="
        isPeekPriceModalFlightPlusHotelItinerary(props.itinerary) ||
        isPeekPriceModalFerryPlusHotelItinerary(props.itinerary)
      "
      :itinerary="props.itinerary"
    />

    <PeekPriceMultiIngredient
      v-if="isPeekPriceModalMultiIngredientItinerary(props.itinerary)"
      :itinerary="props.itinerary"
    />
  </div>
</template>
